import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { Fragment, createElement, cloneElement, useState, useEffect, useRef } from 'react';
import { insert } from 'svelte/internal';
import SvelteProducts from './svelte';

var Products = function Products(_ref) {
  var trigger = _ref.trigger,
      active = _ref.active,
      isCompact = _ref.isCompact,
      isColumn = _ref.isColumn,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      dropdownClassName = _ref.dropdownClassName;
  var ref = useRef(null);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    var _a;

    var node = ref.current;
    if (!node) return;

    var createDefaultSlot = function createDefaultSlot() {
      return {
        c: function c() {},
        m: function m(target, anchor) {
          insert(target, node, anchor);
        },
        d: function d() {}
      };
    };

    var fragment = document.createDocumentFragment();
    var svelte = new SvelteProducts({
      target: trigger ? node.parentNode : fragment,
      props: {
        class: className,
        activeClass: activeClassName,
        dropdownClassName: dropdownClassName,
        isCompact: isCompact,
        isColumn: isColumn,
        active: active,
        $$slots: trigger ? {
          default: [createDefaultSlot]
        } : undefined,
        $$scope: {
          ctx: {}
        }
      }
    });

    if (!trigger) {
      (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(fragment, node);
      setMounted(null);
    }

    return function () {
      return svelte.$destroy();
    };
  }, []);

  if (trigger) {
    return createElement(Fragment, null, cloneElement(trigger, {
      ref: ref
    }));
  }

  return mounted && createElement('p', {
    ref: ref,
    className: 'hide'
  });
};

export default Products;